'use client';

import Image from 'next/image';
import WhatsappIcon from '../../icons/WhatsappIcon';
import InstagramIcon from '../../icons/InstagramIcon';
import React from 'react';
import MailIcon from '../../icons/MailIcon';

export function FooterClient() {
  return (
    <footer className="flex flex-col items-center w-full bg-primary px-5 py-5 lg:py-10 lg:px-20 lg:max-w-7xl">
      <div className="w-full max-w-7xl flex flex-col sm:flex-row items-center justify-between gap-6 mb-2">
        <div className="flex items-center justify-center sm:justify-start w-full sm:w-auto mt-5 sm:mt-0">
          <Image
            src="/logo-jb-primary.svg"
            alt="Logotipo John Bihuna"
            width={220}
            height={72}
            className="w-auto h-[72px]"
          />
        </div>
        <div className="flex flex-1 flex-col gap-4 sm:flex-row sm:gap-10 items-center justify-end">
          <div className="flex flex-col text-center gap-1">
            <p className="text-xs text-white whitespace-nowrap leading-4">
              John Bihuna – Escritório de Advocacia
            </p>
            <p className="text-xs text-white leading-4">
              R. Maj. Livramento, 654 - Loja 3 - Jardim Universitário, Biguaçu/SC - CEP 88161-036
            </p>
            <p className="text-xs text-white whitespace-nowrap leading-4">
              (48) 99193-9567 | johnbihuna.advogados@gmail.com
            </p>
          </div>
          <div className="flex gap-4">
            <a
              href="https://wa.me/5548991939567?text=Ol%C3%A1%2C%20tudo%20bem%3F%20Vim%20atrav%C3%A9s%20do%20Site%20e%20preciso%20tirar%20uma%20d%C3%BAvida."
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#FFFFFF10] rounded-full p-2 hover:bg-[#C09957] transition-colors"
              aria-label="WhatsApp"
            >
              <WhatsappIcon className="fill-white" />
            </a>
            <a
              href="https://instagram.com/johnbihuna.adv"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#FFFFFF10] rounded-full p-2 hover:bg-[#C09957] transition-colors"
              aria-label="Instagram"
            >
              <InstagramIcon className="fill-white" />
            </a>
            <a
              href="mailto:johnbihuna.advogados@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#FFFFFF10] rounded-full p-2 hover:bg-[#C09957] transition-colors"
              aria-label="Email"
            >
              <MailIcon className="fill-white" />
            </a>
          </div>
        </div>
      </div>
      <hr className="w-full border-[#FFFFFF20] my-4" />
      <p className="text-sm text-white w-full text-center sm:text-left">
        ©{new Date().getFullYear()} – Todos os direitos reservados.
      </p>
    </footer>
  );
}
